import React from 'react';
import PaymentsBookings from '@/dashboard/scenes/PaymentsBookings';
import { CHARGE_HAS_COUPON_REDEEMED_STATUSES } from '@/dashboard/services/status/hasCouponRedeemedStatuses';
import { COUPON_FILTER_OPTIONS } from '@/dashboard/lib/chargesConstants';

const DiscountsCouponsBookingsRedemptions = ({ coupon }) => {
  return (
    <PaymentsBookings
      title="Event booking redemptions"
      baseFilters={{
        'coupon._id': coupon._id,
        status: CHARGE_HAS_COUPON_REDEEMED_STATUSES,
      }}
      hasCustomStatusFilter
      exportLabel="coupon redemptions"
      hidePageFilter
      embedded
      filterOptions={COUPON_FILTER_OPTIONS}
    />
  );
};

export default DiscountsCouponsBookingsRedemptions;
